var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 12.9125V18C14.9999 18.3788 14.7859 18.725 14.4472 18.8944L10.4472 20.8944C9.78226 21.2269 8.99994 20.7434 8.99994 20V12.9125L2.22599 4.63324C1.69177 3.98031 2.15632 3 2.99994 3H20.9999C21.8436 3 22.3081 3.98031 21.7739 4.63324L14.9999 12.9125ZM12.9999 17.382V12.5556C12.9999 12.3247 13.0798 12.101 13.226 11.9223L18.8897 5H5.11019L10.7739 11.9223C10.9201 12.101 10.9999 12.3247 10.9999 12.5556V18.382L12.9999 17.382Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.9f6fb913781fff0761eccbe8731cd1f5.svg";
export { ForwardRef as ReactComponent };